import { logTrackingEvent } from '@/utils/tracking';
import NextLink from 'next/link';

import type { LinkProps as NextLinkProps } from 'next/link';
import type { ReactNode } from 'react';
import type { TrackingEventObject } from '@/types/tracking';

type BaseProps = NextLinkProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
    children: ReactNode;
  };

// Default: eventText is required
type DefaultTrackingProps = BaseProps & {
  eventText: string;
  tracking?: undefined;
};

// If providing a tracking override, then eventText is no longer required
type PayloadOverrideProps = BaseProps & {
  eventText?: string;
  tracking: TrackingEventObject;
};

export type LinkProps = DefaultTrackingProps | PayloadOverrideProps;

/**
 * @deprecated Use `next/link` directly with explicit tracking via
 * `logTrackingEvent`. This component conflates navigation and analytics.
 */
export const Link = (props: LinkProps) => {
  const { href, onClick, children, eventText, tracking, ...rest } = props;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    onClick?.(e);

    if (tracking) {
      logTrackingEvent({
        ...tracking,
        click_url: tracking.click_url ?? href,
      });
      return;
    }

    logTrackingEvent({
      event: 'interaction_click',
      component_name: 'link',
      click_text: eventText,
      click_url: href,
    });
  };

  return (
    <NextLink {...rest} href={href} onClick={handleClick}>
      {children}
    </NextLink>
  );
};
